import React, { useEffect } from 'react';
import Link from 'next/link';

import NavbarSlider from '../ui/components/NavbarCarousel';

const PageNavbar = ({ entity, navbar, url, pathValue }: any) => {
const handleScroll = () => {
  let scrollToValue = 0;

  if (window.innerWidth < 768) {
    scrollToValue = 120;
  } else if (window.innerWidth >= 768) {
    scrollToValue = 260;
  }

  setTimeout(() => {
    window.scrollTo({ top: scrollToValue, behavior: "smooth" });
  }, 200);
};

// useEffect(() => {
//   if (typeof window !== "undefined") {
//     handleScroll();
//   }
// }, []);

  return (
    <div className="sticky !top-16 z-50 md:!top-[88px]">
      <div className=" mx-auto flex border-b border-b-primary-light bg-white lg:max-w-[73.75rem] 2xl:max-w-screen-xl">
        <div className="w-[98vw] px-1 md:w-full md:px-4 md:py-0 lg:mx-auto lg:max-w-[73.75rem] 2xl:max-w-screen-xl">
          <NavbarSlider
            buttonBorderColor="border-primary-text"
            buttonTextColor="text-primary-text"
            slides={navbar?.map((tab: any) => {
              const tabPath = `/${entity}/${url}/${tab?.title?.replace(/\s+/g, '-').toLowerCase()}`;
              return (
                <Link key={tab?.id} href={tabPath} scroll={false}>
                  <button
                    className={`${
                      pathValue === tab?.title?.replace(/\s+/g, '-').toLowerCase()
                        ? 'border-b-2 border-primary text-primary'
                        : ''
                    } !w-full cursor-pointer text-sm hover:border-b-2 hover:border-primary hover:text-primary md:pb-0.5`}
                    onClick={handleScroll}
                    style={{ minWidth: 'fit-content' }}
                  >
                    {tab?.title}
                  </button>
                </Link>
              );
            })}
          />
        </div>
      </div>
    </div>
  );
};

export default PageNavbar;
